import { Injectable } from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import { ApiService } from "../services/api.service";
import { BehaviorSubject, Observer, Subject } from "rxjs"; 
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { ApiCollection } from "../providers/api-collection";  
import { CostApprovalResponseModel } from "../models/cost-approval-model";
import { AddCostApprovalComponent } from "../components/add-cost-approval/add-cost-approval.component";
import { TaskReportResponseModel } from "../models/report.model";
import { UserResponseModel } from "../models/task.model";
import { CostApprovalsComponent } from "../pages/action-center/cost-approvals/cost-approvals.component";
import { StanderedResponseModel } from "../models/standered.model";


@Injectable({
    providedIn: "root",
})

export class CostApprovalViewModel {

    parentAddCostApprovalComponent: AddCostApprovalComponent;
    parentCostApprovalsComponent: CostApprovalsComponent

    taskListData = new BehaviorSubject<TaskReportResponseModel>(new TaskReportResponseModel());
    userListData = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
    costApprovalList = new BehaviorSubject<CostApprovalResponseModel>(new CostApprovalResponseModel());
    requestStatusesList = new BehaviorSubject<StanderedResponseModel>(new StanderedResponseModel());


    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) { }

 
    
    subscribeToTaskList(
        observer: Observer<TaskReportResponseModel>,
    ){
        this.taskListData.subscribe(observer);
    }

    getCostApprovalList(page: number, page_size: number, name?: string){
        let url = ApiCollection.Cost_Approval_Process + '?page=' + page + '&page_size=' + page_size;
        if(name){
            url += '&name=' + name;
        }
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action:  url,
            Success: (e: any) => {
                this.costApprovalList.next(e);
                this.parentCostApprovalsComponent.costApprovalReceived();
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    updateCostApprovalStatus(status: number, objectId: number){
        let d: ApiServiceDelegate = {
            Data: {
                id: objectId,
                status: status
            },
            Method: "PATCH",
            Action: ApiCollection.Cost_Approval_Process + '/' + objectId,
            Success: (e: any) => {
                this.parentCostApprovalsComponent.statusUpdated();
                this.message.success("Status updated successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getRequestStatuses(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Cost_Approval_Process_Status + '?page=' + 1 + '&page_size=' + 100,
            Success: (e: any) => {
                this.requestStatusesList.next(e);
                this.parentCostApprovalsComponent.requestStatusesReceived()
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    removeCostApprovalRequest(id: number){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "DELETE",
            Action: ApiCollection.Cost_Approval_Process + '/' + id,
            Success: (e: any) => {
                this.parentCostApprovalsComponent.requestDeleted(id);
                this.message.success("Request deleted successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getUsers(){
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.User + '?page=' + 1 + '&page_size=' + 100 + '&is_deleted=false',
            Success: (e: any) => {
                this.userListData.next(e);
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    getTaskList(name: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: ApiCollection.Task + '?page=' + 1 + '&page_size=' + 10 + 
            '&name=' + encodeURIComponent(name) + "&has_cost_approval=false",
            Success: (e: any) => {
                this.taskListData.next(e);
                this.parentAddCostApprovalComponent.taskDataReceived();
                return e;
            },
            Error: (e: String) => {
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createCostApprovalProcess(approver: number, task_approval: number, comment: string, created_by: number){
        let d: ApiServiceDelegate = {
            Data: { 
                approver: approver,
                task_approval: task_approval,
                comment: comment,
                created_by: created_by
            },
            Method: "POST",
            Action: ApiCollection.Cost_Approval_Process,
            Success: (e: any) => {
                this.parentAddCostApprovalComponent.costApprovalCreated();
                this.message.success("Cost Approval created successfully", { nzDuration: 1000 });
                return e;
            },
            Error: (e: String) => {
                this.message.error(String(e), { nzDuration: 1000 });
                return e;
            },
        };
        this.apiService.callService(d);
    }
}